module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/eaac6d02ce53941bd74e654f61e82970.png";